import React from 'react';
import {observer} from 'mobx-react';
import {ProcessingFile} from '../../../lib/types';

interface ActivityTimelineProps {
    file: ProcessingFile;
}

const ActivityTimeline: React.FC<ActivityTimelineProps> = observer(({file}) => (
    <div className="activity-section">
        <h4>Activity</h4>
        <div className="activity-timeline">
            {file.activity.map((item, idx) => (
                <div key={idx} className="activity-item">
                    <div className="activity-dot" />
                    <div className="activity-content">
                        <div className="activity-time">{item.time}</div>
                        <div className="activity-message">{item.message}</div>
                    </div>
                </div>
            ))}
        </div>
    </div>
));

export default ActivityTimeline;
